import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PermissionsService {
  private readonly STORAGE_KEY = 'permissions';
  
  // WritableSignal instead of BehaviorSubject
  private _permissions: WritableSignal<string[]> = signal(this.readFromSession());

  // Public readonly signal
  public readonly permissions = this._permissions.asReadonly();

  constructor() {
    // Escuchar cambios en sessionStorage desde otras pestañas
    window.addEventListener('storage', (e: StorageEvent) => {
      if (e.key === this.STORAGE_KEY) {
        this._permissions.set(this.parse(e.newValue));
      }
    });
  }

  private readFromSession(): string[] {
    return this.parse(sessionStorage.getItem(this.STORAGE_KEY));
  }

  private parse(raw: string | null): string[] {
    if (!raw) return [];
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : typeof parsed === 'string' ? [parsed] : [];
    } catch {
      return [];
    }
  }

  // Actualiza sessionStorage y emite nuevo valor
  setPermissions(perms: string[] | string | null): void {
    const arr = Array.isArray(perms) ? perms : perms ? [perms] : [];
    sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(arr));
    this._permissions.set(arr);
  }

  clear(): void {
    sessionStorage.removeItem(this.STORAGE_KEY);
    this._permissions.set([]);
  }

  // Getter sincrónico
  getPermissions(): string[] {
    return this._permissions();
  }
}
